import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
import { selectMandolyns } from '../reducers/mandolynsSlice';
export const ConfigMandolynThermometers = () => {
    const mandolyns = useAppSelector(selectMandolyns);
    const sensors = Object.values(mandolyns).sort((a, b) => a.title.localeCompare(b.title));
    const rows = [];
    for (const s of sensors) {
        rows.push(_jsxs("div", { children: [_jsx("div", { children: s.title }), _jsx("div", { children: s.code })] }, s.id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h2", { children: "Mandolyn termometrar" }), _jsx("div", { className: "config-rows config-sensors", children: rows })] }));
};
